import BSModal from 'react-bootstrap/Modal'
import 'lib/reactBootstrapReact19/modal'
import classNames from 'classnames'

import styles from './index.module.scss'

const Modal: React.FC<ModalProps> = ({
  show,
  children,
  onHide = () => null,
  size = 'lg',
  modalType = 'centered',
  backdrop = null,
  backdropClassName = '',
  keyboard = true,
  dialogClassOverride = '',
  contentClassOverride = '',
}) => {
  let dialogClassName, contentClassName

  switch (modalType) {
    case 'centered':
      dialogClassName = `d-flex align-items-center overflow-auto h-100 m-auto`
      // https://stackoverflow.com/questions/33454533/cant-scroll-to-top-of-flex-item-that-is-overflowing-container
      contentClassName = `${styles.modal_border_radius} overflow-auto m-auto h-100 h-md-unset`
      break
    //Used for full screen modal in mobile view and fixed height centered modal for desktop view without overflow
    case 'fixed-height':
      dialogClassName = 'd-flex align-items-center h-100 m-auto'
      contentClassName = `${styles.modal_border_radius} h-100 h-md-85`
      break
    case 'centered-no-overflow':
      dialogClassName = `d-flex align-items-center h-100 m-auto`
      contentClassName = `m-auto h-100 h-md-unset`
      break
    //Used as a normal sized always centered modal in all the views but with overflow
    case 'centered-content-height':
      dialogClassName = `d-flex align-items-center overflow-auto h-100 m-auto modal-dialog-margin`
      contentClassName = `overflow-auto m-auto h-unset`
      break
    //Used as a normal sized always centered modal in all the views but without overflow
    case 'centered-content-no-overflow':
      dialogClassName = `d-flex align-items-center h-100 m-auto modal-dialog-margin`
      contentClassName = `m-auto h-unset`
      break
  }

  return (
    <BSModal
      show={show}
      onHide={onHide}
      {...(!!backdrop && { backdrop })}
      {...(!!backdropClassName && { backdropClassName })}
      {...(typeof keyboard === 'boolean' && { keyboard })}
      //bootstrap doesn't have a xs and md size in their type for size
      //we have a xs and md class for it written in main.scss
      //overriding to avoid linting error
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      //@ts-ignore
      size={size}
      dialogClassName={classNames(
        dialogClassName,
        dialogClassOverride,
        '~font-roboto'
      )}
      backdropClassName={backdropClassName}
      contentClassName={classNames(
        'card',
        contentClassName,
        contentClassOverride
      )}
    >
      {children}
    </BSModal>
  )
}

export default Modal
